// jobDetailsListing.tsx
//@ts-nocheck

import React, {
  Fragment,
  HTMLProps,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  ColumnDef,
  PaginationState,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  Row,
} from "@tanstack/react-table";
import { Link, useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import { BASE_URL } from "../../../utils/api";
import { toast } from "sonner";
import { debounce } from "lodash";
import { Dialog, Listbox, Transition } from "@headlessui/react";
import CustomMenuDropdown from "../../../components/common/CustomMenuDropdown";
import { getToken } from "../../../utils/localStorage";
import axios from "axios";
import { useAppDispatch,useAppSelector } from "../../../app/hooks";
import { ExclamationIcon } from "../../../components/icons";
import { ChevronDownIcon, CrossIcon } from "../../../components/icons/Icons";
import { DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import {
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import LoadingBar from "react-top-loading-bar";
import { fetchDepartmentList } from "../../../features/department/departmentSlice";
import { updateDocument } from "../../../features/job/jobSlices";
import { fetchJobPipelineDetailsData } from "../../../features/pipeline/pipelineSlice";
import { useSidebar } from "../../../context/SidebarContext";
import { useSidebarMenu } from "../../../context/CustomVerticalMenuContext";
import {
  updateMultiApplicationData,
} from "../../../features/ApplicationData/ApplicationDataSlice";
import { fetchPipelineStagesList } from "../../../features/tags/tagsSlice";
import {
  fetchJobPipelineDetailsDataChange,
} from "../../../features/hiringpipeline/hiringPipelineSlice";
import QuickViewResponse from "../QuickViewResponse";

type Person = {
  doc_status: any;
  doc_sub_status: any;
  id: any;
  created_at: string | number | Date;
  internal: any;
  doc_tag: any;
  external: any;
  channel_id: any;
  item_refernce_id: ReactNode;
  name: string;
  email: string;
  age: string;
  type: string;
  typeColor: string;
  status: string;
  statusColor: string;
  progress?: string;
  avatar?: string;
};

interface topicTableProps {
  sectionHeight?: number;
}

interface DropdownItem {
  className?: string;
  icon?: ReactNode;
  label: string;
  shortcut?: any;
  disabled?: boolean;
  onClick?: () => void;
  href?: string;
}

interface Status {
  id: number;
  name: string;
  label: string;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const statusItem: Status[] = [
  { id: 101, name: "completed", label: "#15803d" },
  { id: 102, name: "rejected", label: "#b91c1c" },
  { id: 103, name: "terminated", label: "#3b82f6" },
  { id: 104, name: "expired", label: "#b91c1c" },
  { id: 105, name: "pending", label: "#854d0e" },
  { id: 106, name: "draft", label: "#4b5563" },
];

localStorage.setItem("itemStatusList", JSON.stringify(statusItem));

const sub_StatusItem: Status[] = [
  { id: 101, name: "completed-view", label: "#15803d" },
  { id: 102, name: "completed", label: "#15803d" },
  { id: 103, name: "completed-accept", label: "#15803d" },
  { id: 104, name: "completed-sign", label: "#15803d" },
  { id: 105, name: "completed-payment", label: "#15803d" },
  { id: 106, name: "pending-accept", label: "#854d0e" },
  { id: 107, name: "pending-sign", label: "#854d0e" },
  { id: 108, name: "pending-payment", label: "#854d0e" },
  { id: 109, name: "pending-input", label: "#854d0e" },
  { id: 110, name: "pending-view", label: "#854d0e" },
  { id: 111, name: "pending-approval", label: "#854d0e" },
  { id: 112, name: "sent", label: "#4b5563" },
  { id: 113, name: "draft", label: "#4b5563" },
];

localStorage.setItem("itemSubStatusList", JSON.stringify(sub_StatusItem));

function IndeterminateCheckbox({
  indeterminate,
  className = "",
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = React.useRef<HTMLInputElement>(null!);

  React.useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className="h-4 w-4 rounded border-gray-300 text-indigo-600 ring-0 outline-none focus:outline-none focus:shadow-none focus:ring-transparent"
      {...rest}
    />
  );
}

var date = new Date();
var formattedDate = date.toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

export const colorMap = {
  numbers: {
    "0": "#ffc107",
    "1": "#ff9900",
    "2": "#ffa07a",
    "3": "#e67e73",
    "4": "#d35400",
    "5": "#e74c3c",
    "6": "#f39c12",
    "7": "#ff8c00",
    "8": "#ffb6c1",
    "9": "#ff69b4",
  },
  alphabets: {
    a: "#ff9900",
    b: "#ffc107",
    c: "#ffa07a",
    d: "#e67e73",
    e: "#d35400",
    f: "#e74c3c",
    g: "#f39c12",
    h: "#ff8c00",
    i: "#ffb6c1",
    j: "#ff69b4",
    k: "#ffc499",
    l: "#ffa57d",
    m: "#e6b8a3",
    n: "#d2b48c",
    o: "#ff9900",
    p: "#ffc107",
    q: "#ffa07a",
    r: "#e67e73",
    s: "#d35400",
    t: "#e74c3c",
    u: "#f39c12",
    v: "#ff8c00",
    w: "#ffb6c1",
    x: "#ff69b4",
    y: "#ffc499",
    z: "#ffa57d",
  },
};

export const getColorForLabel = (label: string): string => {
  const firstChar = label?.charAt(0).toLowerCase();
  if (firstChar >= "0" && firstChar <= "9") {
    return (
      colorMap.numbers[firstChar as keyof typeof colorMap.numbers] || "#808080"
    );
  } else if (firstChar >= "a" && firstChar <= "z") {
    return (
      colorMap.alphabets[firstChar as keyof typeof colorMap.alphabets] ||
      "#808080"
    );
  }
  return "#808080";
};

const BookmarkListing: React.FC<topicTableProps> = ({
  sectionHeight,
  activeFilters,
  itemAssignedTo,
  itemStatusDraft,
  itemStatusPending,
  itemStatusCompleted,
}: any) => {
  const [data, setData] = React.useState<any[]>([]);
  const [rowSelection, setRowSelection] = React.useState({});
  const [selectedRows, setSelectedRows] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [isModalOpenCheckbox, setIsModalOpenCheckbox] = useState(false);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [deleteOk, setDeleteOk] = useState(false);
  const [rowSelectionDelete, setRowSelectionDelete] = useState<number[]>([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const isInitialMount = useRef(true);
  const [initialLoading, setInitialLoading] = useState(true);
  // Fetch channelData from localStorage
  const channelDataString = localStorage.getItem("channelData");
  const channelData = channelDataString ? JSON.parse(channelDataString) : [];
  const [teams, setTeams] = useState(null);
  const [tagsList, setTagsList] = useState(null);
  const [selectRole, setSelectRole] = useState<any>("");

  // item status data
  const itemStatus = localStorage.getItem("itemStatusList");
  const statusData = itemStatus ? JSON.parse(itemStatus) : [];

  // item tags data
  const itemTags = localStorage.getItem("itemTagsList");
  const tagsData = itemTags ? JSON.parse(itemTags) : [];

  // item priority
  const itemPriority = localStorage.getItem("priorities");
  const priorityData = itemPriority ? JSON.parse(itemPriority) : [];
  const dispatch = useAppDispatch();
  const [addTags, setAddTags] = useState(false);
  const [tagsOpen, setTagsOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState("");
  const [searchTags, setSearchTags] = useState("");
  const loadingBarRef = useRef(null);
  const { jobId } = useParams<{ jobId: string }>();
  const [pipelineStageData, setPipelineStageData] = useState("");
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  const storedFilters = localStorage.getItem("activeFiltersBookmark");
  const initialFilters = storedFilters ? JSON.parse(storedFilters) : null;
  const [pagination, setPagination] = React.useState<PaginationState>({
    pageIndex: initialFilters?.pagination?.pageIndex || 0,
    pageSize: initialFilters?.pagination?.pageSize || 25,
    currentPage: initialFilters?.pagination?.currentPage || 1,
    hasNextPage: false,
    totalPages: 1,
    totalItems: 0,
  });
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [quickViewMode, setQuickViewMode] = useState(false);
  const [quickData, setQuickData] = useState({});
  const [openTeamModal, setOpenTeamModal] = useState(false);
  const [pipelineStageDataUser, setPipelineStageDataUser] = useState([]);
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [assignMember, setAssignMember] = useState(null);
  const [isAssign, setIsAssign] = useState(false);
  const [tagsLoading, setTagsLoading] = useState(false);
  const [addStage, setAddStage] = useState(false);
  const [stageLoading, setStageLoading] = useState(false);
  const [selectStage, setSelectStage] = useState("");
  const [stageList, setStageList] = useState(null);
  const { customVerticalSidebar } = useSidebarMenu();
     const isChatOpen = useAppSelector((state: any) => state.ui?.isChatbotOpen);
  const navigate = useNavigate();

  const _get_ItemFeedbackList = async (
    pageIndex: number,
    pageSize: number,
    filters: Filters,
    assignedTo: boolean,
    itemStatusDraft: boolean,
    itemStatusPending: boolean,
    itemStatusCompleted: boolean,
  ) => {
    const baseId =
      localStorage.getItem("UserBaseId") ||
      localStorage.getItem("createBaseId");
    if (!baseId) return;

    try {
      setLoading(true);

      // Ensure baseId is valid for URL construction
      const parsedBaseId = isNaN(Number(baseId)) ? baseId : JSON.parse(baseId);
      const url = `${BASE_URL}/${parsedBaseId}/${jobId}/application.bookmarkList`;
      const params = new URLSearchParams({
        page: pageIndex.toString(),
        limit: pageSize.toString(),
      });

      // Add filters logic
      if (filters) {
        Object.entries(filters).forEach(([filterType, filterValues]) => {
          if (filterType === "search") return; // Handle search separately

          if (Array.isArray(filterValues) && filterValues.length > 0) {
            const keyPrefix = getKeyPrefix(filterType);

            filterValues.forEach((filterObj: FilterValue) => {
              let value: string | undefined;
              // Filter handling logic
              if (
                filterType === "Stages" ||
                filterType === "tags" ||
                filterType === "internal"
              ) {
                value = filterObj.id;
              } else if (
                filterType === "status" ||
                filterType === "subStatus" ||
                filterType === "priority"
              ) {
                value = filterObj.value;
              } else if (filterType === "member") {
                value = String(filterObj.value);
              } else if (filterType === "Sort") {
                const sortValue = filterObj.value;
                // Set default sort values
                let orderingKey = "created_at";
                let order = "desc";

                // Determine orderingKey
                if (sortValue === "AI rating accending") {
                  orderingKey = "ai_rating";
                  order = "asc";
                } else if (sortValue === "AI rating decending") {
                  orderingKey = "ai_rating";
                  order = "desc";
                } else if (sortValue === "User rating accending") {
                  orderingKey = "user_rating";
                  order = "asc";
                } else if (sortValue === "User rating decending") {
                  orderingKey = "user_rating";
                  order = "desc";
                } else if (sortValue.includes("Updated")) {
                  orderingKey = "updated_at";
                  order = sortValue.includes("first") ? "asc" : "desc";
                } else {
                  orderingKey = "created_at";
                  order = sortValue.includes("first") ? "asc" : "desc";
                }

                params.set("orderingKey", orderingKey);
                params.set("order", order);
              } else if (filterType === "AI rating") {
                // Convert the text rating to a numerical value
                let ratingValue;

                switch (filterObj.value) {
                  case "Strong Yes":
                    ratingValue = 5;
                    break;
                  case "Yes":
                    ratingValue = 4;
                    break;
                  case "Neutral":
                    ratingValue = 3;
                    break;
                  case "No":
                    ratingValue = 2;
                    break;
                  case "Strong No":
                    ratingValue = 1;
                    break;
                  default:
                    // If there's no match, don't add any parameter
                    return;
                }

                // Add the value as a range (from-to)
                params.append("ai_rating_from", ratingValue.toString());
                // params.append('ai_rating_to', ratingValue.toString());
              } else if (filterType === "User rating") {
                // Define the ranges based on the text rating
                let fromValue: number | undefined;
                let toValue: number | undefined;

                switch (filterObj.value) {
                  case "Strong Yes":
                    fromValue = 3.5;
                    toValue = 4.0;
                    break;
                  case "Yes":
                    fromValue = 1.5;
                    toValue = 3.4;
                    break;
                  case "Neutral":
                    fromValue = 0.5;
                    toValue = 1.4;
                    break;
                  case "No":
                    fromValue = -1.5;
                    toValue = 0.4;
                    break;
                  case "Strong No":
                    fromValue = -2.0;
                    toValue = -1.6;
                    break;
                  default:
                    // If there's no match, don't add any parameter
                    return;
                }

                // Add the range parameters
                if (fromValue !== undefined && toValue !== undefined) {
                  params.append("user_rating_from", fromValue.toString());
                  params.append("user_rating_to", toValue.toString());
                }
              } else if (filterType === "Created at") {
                const [startDate, endDate] = (filterObj.value || "")
                  .split(" - ")
                  .map((dateStr) => {
                    const date = parseDate(dateStr);
                    date.setHours(12, 0, 0, 0);
                    return date;
                  });
                params.append("submitted_from", formatDate(startDate));
                params.append("submitted_till", formatDate(endDate));
                return;
              } else if (filterType === "Updated at") {
                const [startDate, endDate] = (filterObj.value || "")
                  .split(" - ")
                  .map((dateStr) => {
                    const date = parseDate(dateStr);
                    date.setHours(12, 0, 0, 0);
                    return date;
                  });
                params.append("updated_from", formatDate(startDate));
                params.append("updated_till", formatDate(endDate));
                return;
              }

              if (value !== undefined) {
                params.append(keyPrefix, value.toString());
              }
            });
          }
        });

        // Handle search filter
        if (filters.search) {
          params.append("search", filters.search);
        }
      }

      // Handle assigned items
      if (assignedTo) {
        params.append("doc_flag", "archive");
      }

      // Handle mutually exclusive status parameters
      if (itemStatusDraft) {
        params.append("doc_status", "draft");
      } else if (itemStatusPending) {
        params.append("doc_status", "pending");
      } else if (itemStatusCompleted) {
        params.append("doc_status", "completed");
      }

      // // Handle draft items
      // if (itemStatusDraft) {
      //   params.append('doc_status', 'draft');

      // }

      // // Handle pending items
      // if (itemStatusPending) {
      //   params.append('doc_status', 'pending');
      // }

      // // Handle completed items
      // if (itemStatusCompleted) {
      //   params.append('doc_status', 'completed');
      // }

      // Make the GET request
      const response = await axios.get(url, {
        params: params,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      return response;
    } catch (error) {
      console.error("Error fetching items:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeFilters?.search) {
      // Reset pagination when search filter changes
      setPagination((prev) => ({
        ...prev,
        pageIndex: 0,
        currentPage: 1, // Reset to page 1
      }));
      // Fetch data for the updated pagination and filters
      fetchItemFeedbackListData(
        0, // Reset to pageIndex 0
        pagination.pageSize,
        activeFilters,
        false, // Not an initial fetch
        itemAssignedTo,
        itemStatusDraft,
        itemStatusPending,
        itemStatusCompleted,
      );
    }
  }, [activeFilters?.search]); // Only trigger when the search filter changes

  // Helper function to get the key prefix based on filter type
  const getKeyPrefix = (filterType) => {
    switch (filterType) {
      case "Stages":
        return "stage_id";
      case "member":
        return "external";
      case "status":
        return "doc_status";
      case "subStatus":
        return "doc_sub_status";
      case "tags":
        return "doc_tag";
      case "priority":
        return "item_priority";
      case "internal":
        return "internal";
      case "Created at":
        return "submitted_from";
      case "Updated at":
        return "updated_from";
      case "AI rating":
        return "ai_rating";
      case "User rating":
        return "user_rating";
      default:
        return filterType.toLowerCase();
    }
  };

  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split(" ");
    const monthIndex = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ].indexOf(month);
    return new Date(year, monthIndex, parseInt(day));
  };

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const fetchItemFeedbackListData = useCallback(
    debounce(
      async (
        pageIndex,
        pageSize,
        filters,
        isInitialFetch = false,
        itemAssignedTo,
        itemStatusDraft,
        itemStatusPending,
        itemStatusCompleted,
      ) => {
        if (loadingBarRef.current) {
          loadingBarRef.current.continuousStart();
        }
        setLoading(true);
        try {
          const response = await _get_ItemFeedbackList(
            pageIndex,
            pageSize,
            filters,
            itemAssignedTo,
            itemStatusDraft,
            itemStatusPending,
            itemStatusCompleted,
          );

          if (response.status === 200) {
            const newData = response.data.data.jobApplication;
            const newPagination = {
              currentPage: response.data.data.currentPage,
              hasNextPage: response.data.data.hasNextPage,
              totalPages: response.data.data.totalPages,
              pageSize: response.data.data.limit,
              pageIndex: response.data.currentPage - 1,
              total: response.data.data.totalJobApplication,
            };

            setData(newData);
            setPagination(newPagination);
            setTotalPages(response.data.data.totalPages);
            localStorage.setItem(
              "cachedBookmarkData",
              JSON.stringify({
                data: newData,
                pagination: newPagination,
                timestamp: Date.now(),
              }),
            );
            if (!isInitialFetch) {
              console.log("Data updated in background");
            }
          }
        } catch (error) {
          console.error("Error fetching item feedback list:", error);
        } finally {
          if (loadingBarRef.current) {
            loadingBarRef.current.complete();
          }
          setLoading(false);
          if (isInitialFetch) {
            setInitialLoading(false);
          }
        }
      },
      500,
    ),
    [],
  ); // Adjust the debounce delay as needed

  useEffect(() => {
    const handleSidebarItemClick = () => {
      setPagination({
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1,
        hasNextPage: false,
        totalPages: 1,
        total: 0,
      });
      setTotalPages(0);
      fetchItemFeedbackListData(1, 25, true);
    };

    window.addEventListener("paginationresetsetate", handleSidebarItemClick);

    return () => {
      window.removeEventListener(
        "paginationresetsetate",
        handleSidebarItemClick,
      );
    };
  }, [fetchItemFeedbackListData]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      const cachedData = localStorage.getItem("cachedBookmarkData");
      if (cachedData) {
        setLoading(true);
        const { data: cachedItems, pagination: cachedPagination } =
          JSON.parse(cachedData);
        setData(cachedItems);
        setPagination((prevPagination) => ({
          ...prevPagination,
          ...cachedPagination,
        }));
        setTotalPages(cachedPagination.totalPages);
        setLoading(false);
      } else {
        fetchItemFeedbackListData(
          pagination.currentPage,
          pagination.pageSize,
          activeFilters,
          true,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted,
        );
      }
    } else {
      fetchItemFeedbackListData(
        pagination.currentPage,
        pagination.pageSize,
        activeFilters,
        true,
        itemAssignedTo,
        itemStatusDraft,
        itemStatusPending,
        itemStatusCompleted,
      );
    }
  }, [
    fetchItemFeedbackListData,
    pagination.currentPage,
    pagination.pageSize,
    activeFilters,
    itemAssignedTo,
    itemStatusDraft,
    itemStatusPending,
    itemStatusCompleted,
  ]);

  const handlePrevPage = () => {
    setLoading(false);
    if (pagination.currentPage > 1) {
      setPagination((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }
  };

  const handleNextPage = () => {
    setLoading(false);
    if (pagination.hasNextPage) {
      setPagination((prev) => ({ ...prev, currentPage: prev.currentPage + 1 }));
    }
  };

  useEffect(() => {
    const handleSidebarItemClick = () => {
      setData([]);
      setPagination({
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1,
        hasNextPage: false,
        totalPages: 1,
        total: 0,
      });
      setTotalPages(0);
      fetchItemFeedbackListData(1, 25, true);
    };

    window.addEventListener("sidebarItemClicked", handleSidebarItemClick);

    return () => {
      window.removeEventListener("sidebarItemClicked", handleSidebarItemClick);
    };
  }, [fetchItemFeedbackListData]);

  const handleSelect = (row: Row<Person>) => {
    setSelectedRows((prevSelectedRows) => {
      const newRowState = { ...prevSelectedRows };
      newRowState[row.id] = !prevSelectedRows[row.id];
      return newRowState;
    });
  };

  const handleTagsSelect = async (tag, id) => {
    setSelectedTags((prev) => ({
      ...prev,
      [id]: tag,
    }));
    setTagsOpen(null);
    setSearchTags("");

    try {
      const payload = {
        id,
        baseId,
        job_tag: String(tag.id),
      };

      const result = await dispatch(updateDocument(payload)).unwrap();
      toast.success("Tags updated successfully");
    } catch (error) {
      console.error("Failed to update tag:", error);
      toast.error("Failed to update tag");
    }
  };

  const handleTagsSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchTags(searchTerm);
  };

  const filteredTags =
    tagsList?.data?.filter((tag) => {
      const fullName = `${tag.tag_name || ""}`.toLowerCase();
      return fullName.includes(searchTags);
    }) || [];

  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const allStages = JSON.parse(storedBase);
          setPipelineStageData(allStages);
        } else {
          try {
            const res = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            localStorage.setItem(
              "jobPipelineStageData",
              JSON.stringify(res.data),
            );
            setPipelineStageData(res?.data);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  // Create a memoized mapping of stage IDs to stage names
  const stageNameMap = useMemo(() => {
    if (!pipelineStageData?.stages) return {};
    return pipelineStageData.stages.reduce((acc, stage) => {
      acc[stage.id] = {
        name: stage.stage_name,
        color: stage.stage_colour,
      };
      return acc;
    }, {});
  }, [pipelineStageData]);

  // Add a useEffect to update localStorage when pagination changes
  useEffect(() => {
    const storedFilters = localStorage.getItem("activeFiltersBookmark");
    if (storedFilters) {
      const filters = JSON.parse(storedFilters);
      localStorage.setItem(
        "activeFiltersBookmark",
        JSON.stringify({
          ...filters,
          pagination: {
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize,
            currentPage: pagination.currentPage,
          },
        }),
      );
    }
  }, [pagination]);

  // Function to get badge styles based on rating value
  const getRatingBadgeStyles = (rating: any) => {
    if (!rating)
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) {
      // Strong Yes: Green
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10",
      };
    } else if (ratingValue === 4) {
      // Yes: Light Green
      return {
        bg: "bg-emerald-50",
        text: "text-emerald-700",
        ring: "ring-emerald-700/10",
      };
    } else if (ratingValue === 3) {
      // Neutral: Blue
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10",
      };
    } else if (ratingValue === 2) {
      // No: Orange
      return {
        bg: "bg-orange-50",
        text: "text-orange-700",
        ring: "ring-orange-700/10",
      };
    } else if (ratingValue === 1) {
      // Strong No: Red
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10",
      };
    } else {
      // Default style for any other values
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    }
  };

  const getRatingLabel = (rating: any) => {
    if (!rating) return null;

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) return "Strong Yes";
    if (ratingValue === 4) return "Yes";
    if (ratingValue === 3) return "Neutral";
    if (ratingValue === 2) return "No";
    if (ratingValue === 1) return "Strong No";

    return null;
  };

  const getSkillScaleBadgeStyles = (scale: any) => {
    // Parse the scale value to ensure it's a number
    const scaleValue = parseFloat(scale);

    // Set badge styles based on ranges
    if (scaleValue >= 3.5 && scaleValue <= 4.0) {
      // Expert: Green
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10",
      };
    } else if (scaleValue >= 1.5 && scaleValue <= 3.4) {
      // Proficient: Blue
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10",
      };
    } else if (scaleValue >= 0.5 && scaleValue <= 1.4) {
      // Competent: Yellow
      return {
        bg: "bg-yellow-50",
        text: "text-yellow-700",
        ring: "ring-yellow-700/10",
      };
    } else if (scaleValue >= -1.5 && scaleValue <= 0.4) {
      // Limited: Orange
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    } else if (scaleValue >= -2.0 && scaleValue <= -1.6) {
      // Inadequate: Red
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10",
      };
    } else {
      // Default style for any other values
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10",
      };
    }
  };

  // Function to get skill level label based on scale value
  const getSkillLevelLabel = (scale: any) => {
    const scaleValue = parseFloat(scale);
    if (scaleValue >= 3.5 && scaleValue <= 4.0) return "Strong Yes";
    if (scaleValue >= 1.5 && scaleValue <= 3.4) return "Yes";
    if (scaleValue >= 0.5 && scaleValue <= 1.4) return "Neutral";
    if (scaleValue >= -1.5 && scaleValue <= 0.4) return "No";
    if (scaleValue >= -2.0 && scaleValue <= -1.6) return "Strong No";
    return null;
  };

  const handleQuickMode = (row: any) => {
    setQuickData(row);
    setQuickViewMode(true);
  };

  const darkenColor = (color: string, amount = 40) => {
    const num = parseInt(color.replace("#", ""), 16);
    let r = (num >> 16) - amount;
    let g = ((num >> 8) & 0x00ff) - amount;
    let b = (num & 0x0000ff) - amount;

    r = r < 0 ? 0 : r;
    g = g < 0 ? 0 : g;
    b = b < 0 ? 0 : b;

    return `rgb(${r}, ${g}, ${b})`;
  };

  const columns = useMemo<ColumnDef<Person>[]>(
    () => [
      {
        id: "select",
        header: ({ table }) => (
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: (e) => {
                table.getToggleAllRowsSelectedHandler()(e);
                handleCheckboxClick(table);
              },
            }}
          />
        ),
        cell: ({ row }) => (
          <div className="px-1">
            <IndeterminateCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: (e) => {
                  row.getToggleSelectedHandler()(e);
                  handleCheckboxClick(row, row.original.id);
                },
              }}
            />
          </div>
        ),
      },
      {
        accessor: "name",
        header: "Name",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          return (
            // <Link to={`/${baseId}/job/${jobId}/app/${id}/overview`} className='w-full'>
            <button
              className="w-full text-left"
              onClick={() => handleQuickMode(info.row.original)}
            >
              <div className="relative">
                <div className="table-tooltip hover:overflow-visible tabletooltip-title">
                  <div className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-1  min-w-[200px]">
                    {info?.row?.original?.app_name}
                  </div>
                </div>
              </div>
            </button>
            // </Link>
          );
        },
        sort: (a: { name: string }, b: { name: any }) =>
          a.name.localeCompare(b.name),
      },
      {
        accessor: "headline",
        header: "Headline",
        cell: (info) => {
          const { doc_status, id } = info.row.original;

          return (
            <div className="relative ">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                <div className="relative">
                  <div className="table-tooltip hover:overflow-visible tabletooltip-title">
                    <div className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-1">
                      {info?.row?.original?.app_headline}
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          );
        },
        sort: (a: any, b: any) => a.headline.localeCompare(b.headline),
      },
      {
        accessor: "airating",
        header: "AI Rating",
        cell: (info) => {
          const { ai_rating, id } = info.row.original;
          const styles1 = getRatingBadgeStyles(ai_rating);

          return (
            <div className="relative  mq1499:ml-[0px] mq3000:ml-[0px]">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                {ai_rating && (
                  <span
                    className={`inline-flex w-fit items-center rounded-md ${styles1.bg} px-2 py-1 text-xs font-normal ${styles1.text} ring-1 ring-inset ${styles1.ring}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className={`w-3 h-3 mr-[6px] ${styles1.text} `}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                      />
                    </svg>
                    {getRatingLabel(ai_rating)}
                    <span className="ml-[2px]">{`(${ai_rating})`}</span>
                  </span>
                )}
              </Link>
            </div>
          );
        },
        sort: (a: any, b: any) => a.airating.localeCompare(b.airating),
      },
      {
        accessor: "userrating",
        header: "User Rating",
        cell: (info) => {
          const { user_rating, id } = info.row.original;
          const styles = getSkillScaleBadgeStyles(user_rating);
          return (
            <div className="relative  mq1499:ml-[0px] mq3000:ml-[0px]">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                {user_rating && (
                  <span
                    className={`flex mt-1 mb-2  w-fit items-center rounded-md ${styles.bg} px-2 py-1 text-xs font-normal ${styles.text} ring-1 ring-inset ${styles.ring}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className={`w-3 h-3 mr-[6px] ${styles.text} `}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                      />
                    </svg>
                    {getSkillLevelLabel(user_rating)}
                    <span className="ml-[2px]">{`(${user_rating})`}</span>
                  </span>
                )}
              </Link>
            </div>
          );
        },
        sort: (a: any, b: any) => a.userrating.localeCompare(b.userrating),
      },
      {
        accessor: "stage",
        header: "Stage",
        cell: (info) => {
          const { doc_status, id, stage_id } = info.row.original;
          const stageInfo = stageNameMap[stage_id] || {
            name: null,
            color: null,
          };
          return (
            <div className="relative">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                <span
                  className={`inline-flex w-fit items-center rounded-md px-2 py-1 text-xs font-normal`}
                  style={{
                    backgroundColor: `${stageInfo.color}20`,
                    color: stageInfo.color
                      ? darkenColor(stageInfo.color, 90)
                      : "text-gray-600",
                    border: `1px solid ${stageInfo.color}`,
                  }}
                >
                  <span className="">{stageInfo.name}</span>
                </span>
              </Link>
            </div>
          );
        },
        sort: (a: { stage_id: string }, b: { stage_id: string }) => {
          const stageNameA = stageNameMap[a.stage_id]?.name || "";
          const stageNameB = stageNameMap[b.stage_id]?.name || "";
          return stageNameA.localeCompare(stageNameB);
        },
      },
      {
        accessor: "taskdetails",
        header: "Task detail",
        cell: (info) => {
          const { id, task_details } = info.row.original;
          const taskDetails = JSON.parse(task_details);

          const getUserName = (userId: any) => {
            const user = baseMembers.find(
              (member: any) =>
                member.user_id === userId || member.user_id === Number(userId),
            );
            return {
              name: user?.name || "Unknown",
              profileImage: user?.profile_pic || "",
            };
          };

          const reviewer = getUserName(taskDetails?.assigned_to);

          const dueDate = taskDetails?.due_by
            ? new Date(taskDetails.due_by)
            : null;
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Strip time from today for accurate comparison

          const isPastDue = dueDate && dueDate < today;

          const formattedDate = dueDate
            ? dueDate.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
              })
            : null;

          const formattedDateTooltip = dueDate
            ? dueDate.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            : null;

          return (
            <div className="relative">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                <div className="table-tooltip flex items-start gap-x-2">
                  {taskDetails?.assigned_to && (
                    <div
                      className="ml-[0px] table-tooltip-list before:!bottom-[17px] before:!left-[11px]"
                      data-title={reviewer.name}
                    >
                      {reviewer.profileImage ? (
                        <img
                          src={`${process.env.REACT_APP_API_BASE_URL}/${reviewer.profileImage}`}
                          alt={`${"Profile"}`}
                          className="w-4 h-4 rounded-full object-cover"
                        />
                      ) : (
                        <div
                          style={{
                            backgroundColor: getColorForLabel(
                              reviewer.name?.charAt(0),
                            ),
                          }}
                          className="w-4 h-4 rounded-full flex items-center justify-center"
                        >
                          <span className="font-medium text-white text-[11px]">
                            {reviewer.name?.charAt(0)}
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="flex flex-row gap-x-3">
                    {taskDetails?.title && (
                      <div
                        className="table-tooltip-list before:!bottom-[17px] before:!left-[27px] before:!text-[11px]"
                        data-title={taskDetails.type}
                      >
                        <span className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-1 capitalize max-w-[150px]">
                          {taskDetails?.title}
                        </span>
                      </div>
                    )}
                    {formattedDate && (
                      <div
                        className="table-tooltip-list before:!bottom-[17px] before:!left-[27px] before:!text-[11px]"
                        data-title={formattedDateTooltip}
                      >
                        <span
                          className={`text-[13px] ${isPastDue ? "text-red-500" : "text-gray-500"}`}
                        >
                          {formattedDate}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            </div>
          );
        },
        sort: (a: any, b: any) =>
          a.taskdetails?.title?.localeCompare(b.taskdetails?.title),
      },
      {
        accessor: "source",
        header: "Source",
        cell: (info) => {
          const { doc_status, id } = info.row.original;

          return (
            <div className=" relative ">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                <div className=" table-tooltip flex items-center max-w-fit gap-[6px]">
                  <div className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-2 ">
                    {info?.row?.original?.app_source}
                  </div>
                </div>
              </Link>
            </div>
          );
        },
        sort: (a: { source: string }, b: { source: any }) =>
          a.source.localeCompare(b.source),
      },
      {
        accessor: "sourceby",
        header: "Sourced by",
        cell: (info) => {
          const { doc_status, id } = info.row.original;

          return (
            <div className=" relative">
              <Link
                to={`/${baseId}/job/${jobId}/app/${id}/overview`}
                className="w-full"
              >
                <div className=" table-tooltip flex items-center max-w-fit gap-[6px]">
                  <div className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-2 ">
                    {info?.row?.original?.app_source_by}
                  </div>
                </div>
              </Link>
            </div>
          );
        },
        sort: (a: { sourceby: string }, b: { sourceby: any }) =>
          a.sourceby.localeCompare(b.sourceby),
      },
      {
        accessor: "tags",
        header: "Tags",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const redirectUrl =
            doc_status === "draft"
              ? `/${baseId}/d/${id}`
              : doc_status === "pending"
                ? `/${baseId}/d/${id}/pending`
                : `/${baseId}/d/${id}/complete`;
          const tagsId = info.row.original.tag_id;
          const tags = tagsList?.find((team) => team.id === tagsId);

          const tagsName = tags ? tags.tag_name : null;
          const tagsColor = tags ? tags.tag_colour : null;
          return (
            <Link
              to={`/${baseId}/job/${jobId}/app/${id}/overview`}
              className="w-full  mq1499:ml-[0px] mq3000:ml-[0px]"
            >
              <div className="relative flex justify-start">
                {tagsName && (
                  <div className=" table-tooltip flex items-center max-w-fit font-[500] leading-[1.2] bg-light-gray-100 rounded-full text-[0.75rem] px-[0.5rem] py-[5px] gap-[6px]">
                    {tagsColor && (
                      <span
                        className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full
                             border-none text-[0.625rem] font-medium text-white capitalize ${tagsColor}`}
                      ></span>
                    )}
                    <span className="text-[#52555a] font-normal capitalize truncate text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full overflow-hidden text-ellipsis text-start">
                      {tagsName}
                    </span>
                  </div>
                )}
              </div>
            </Link>
          );
        },
        sort: (a: { tags: string }, b: { tags: any }) =>
          a.tags.localeCompare(b.tags),
      },
      {
        accessor: "appliedat",
        header: "Applied at",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const formattedDate = format(
            new Date(info.row.original.submitted_at),
            "MMM d",
          );

          const formattedDatetooltip = info.row.original?.submitted_at
            ? format(
                new Date(info.row.original.submitted_at),
                "d MMMM yyyy, h:mm a",
              )
            : "";

          return (
            <Link
              to={`/${baseId}/job/${jobId}/app/${id}/overview`}
              className="w-full relative flex justify-start"
            >
              <div
                data-title={formattedDatetooltip}
                className="table-tooltip-list before:!bottom-[18px] before:!left-[11px] text-[#52555a] font-normal  text-[13px] leading-4  text-start"
              >
                {formattedDate}
              </div>
            </Link>
          );
        },
        sort: (a: { submitted_at: string }, b: { submitted_at: string }) =>
          new Date(a.submitted_at).getTime() -
          new Date(b.submitted_at).getTime(),
      },
      {
        accessor: "lastupdate",
        header: "Last Update",
        cell: (info) => {
          const { doc_status, id } = info.row.original;
          const formattedDate = format(
            new Date(info.row.original.updated_at),
            "MMM d",
          );
          // const formattedDatetooltip = format(new Date(info.row.original.doc_createdat), 'MMM d');

          const formattedDatetooltip = info.row.original?.updated_at
            ? format(
                new Date(info.row.original.updated_at),
                "d MMMM yyyy, h:mm a",
              )
            : "";

          return (
            <Link
              to={`/${baseId}/job/${jobId}/app/${id}/overview`}
              className="w-full relative flex justify-start "
            >
              <div
                data-title={formattedDatetooltip}
                className="table-tooltip-list before:!bottom-[18px] before:!left-[11px] text-[#52555a] font-normal  text-[13px] leading-4  text-start"
              >
                {formattedDate}
              </div>
            </Link>
          );
        },
        sort: (a: { updated_at: string }, b: { updated_at: string }) =>
          new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime(),
      },
    ],
    [
      teams,
      tagsList?.data,
      tagsList,
      baseId,
      tagsOpen,
      searchTags,
      selectedTags,
      filteredTags,
    ],
  );

  // teams
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseDepartmentData");
        if (storedBase) {
          setTeams(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(fetchDepartmentList(baseId));
            setTeams(baseResponse.payload);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    setSelectedRowsCount(Object.keys(rowSelection)?.length);
  }, [rowSelection]);

  const handleCheckboxClick = (row, id) => {
    setSelectedRows((prevSelectedRows) => ({
      ...prevSelectedRows,
      [row.id]: !prevSelectedRows[row.id],
    }));
    setRowSelectionDelete((prevSelection) => {
      if (prevSelection?.includes(id)) {
        return prevSelection.filter((itemId) => itemId !== id);
      } else {
        return [...prevSelection, id];
      }
    });

    setIsModalOpenCheckbox(true);
  };

  const handleConfirmDelete = (id) => {
    setDeleteOk(true);
  };

  const handleAddTags = (id) => {
    setAddTags(true);
  };

  const handleAddStage = (id) => {
    setAddStage(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setDeleteLoading(true);

      const payload = {
        app_ids: rowSelectionDelete,
        update_key: "app_status",
        update_value: "deleted",
      };

      // Call the API
      const res = await dispatch(
        updateMultiApplicationData({
          baseId: baseId,
          appId: jobId,
          data: payload,
        }),
      );

      if (res.payload.status === 200) {
        // Close modal and show success message
        setDeleteOk(false);
        toast.success("delete item successfully");
        // Create a thunk for this if it doesn't exist yet
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted,
        );

        if (updatedResponse.data.status === 200) {
          const newData = updatedResponse.data.data.jobApplication;
          const newPagination = {
            currentPage: updatedResponse.data.data.currentPage,
            hasNextPage: updatedResponse.data.data.hasNextPage,
            totalPages: updatedResponse.data.data.totalPages,
            pageSize: updatedResponse.data.data.limit,
            pageIndex: updatedResponse.data.currentPage - 1,
            total: updatedResponse.data.data.totalJobApplication,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedBookmarkData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            }),
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse,
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }
    } catch (error) {
      toast.error("Failed to delete application");
      console.error("Assignment error:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteConfirmSingle = async (id) => {
    try {
      setDeleteLoading(true);

      const payload = {
        app_ids: [id],
        update_key: "app_status",
        update_value: "deleted",
      };

      // Call the API
      const res = await dispatch(
        updateMultiApplicationData({
          baseId: baseId,
          appId: jobId,
          data: payload,
        }),
      );

      if (res.payload.status === 200) {
        // Close modal and show success message
        setDeleteOk(false);
        toast.success("delete item successfully");
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted,
        );

        if (updatedResponse.data.status === 200) {
          const newData = updatedResponse.data.data.jobApplication;
          const newPagination = {
            currentPage: updatedResponse.data.data.currentPage,
            hasNextPage: updatedResponse.data.data.hasNextPage,
            totalPages: updatedResponse.data.data.totalPages,
            pageSize: updatedResponse.data.data.limit,
            pageIndex: updatedResponse.data.currentPage - 1,
            total: updatedResponse.data.data.totalJobApplication,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedBookmarkData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            }),
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse,
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }
    } catch (error) {
      toast.error("Failed to delete application");
      console.error("Assignment error:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const table = useReactTable({
    data,
    columns,
    state: {
      pagination,
      rowSelection,
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    debugTable: true,
    onPaginationChange: (newPaginationState) => {
      setPagination(newPaginationState);
      // Update localStorage
      const storedFilters = localStorage.getItem("activeFiltersBookmark");
      if (storedFilters) {
        const filters = JSON.parse(storedFilters);
        localStorage.setItem(
          "activeFiltersBookmark",
          JSON.stringify({
            ...filters,
            pagination: {
              pageIndex: newPaginationState.pageIndex,
              pageSize: newPaginationState.pageSize,
              currentPage:
                newPaginationState.currentPage ||
                newPaginationState.pageIndex + 1,
            },
          }),
        );
      }
    },
  });

  useEffect(() => {
    const applyStyles = () => {
      const tableElement = document.querySelector(
        ".feedback-col",
      ) as HTMLElement | null;
      const tableElement1 = document.querySelector(
        ".feedback-thead",
      ) as HTMLElement | null;
      const isTabScreen = window.matchMedia("(max-width: 1499px)").matches;
      const isSmallScreen = window.matchMedia("(max-width: 767px)").matches;
      const hasSearchFilter = !!activeFilters?.search;

      // Apply margin-top to tableElement based on screen size
      if (tableElement) {
        if (isSmallScreen) {
          tableElement.style.paddingTop = sectionHeight
            ? `calc(50px + ${sectionHeight}px)`
            : "50px";
        } else if (isTabScreen) {
          tableElement.style.paddingTop = sectionHeight
            ? `calc(15px + ${sectionHeight}px)`
            : "45px";
        } else {
          tableElement.style.paddingTop = sectionHeight
            ? `calc(59px + ${sectionHeight}px)`
            : "89px";
        }
      }

      // Apply top style to tableElement1 based on screen size and search filter
      if (tableElement1) {
        if (isSmallScreen) {
          tableElement1.style.top = sectionHeight
            ? `calc(80px + ${sectionHeight}px)`
            : "80px";
        } else if (isTabScreen) {
          tableElement1.style.top = sectionHeight
            ? `calc(101px + ${sectionHeight}px)`
            : "101px";
        } else {
          tableElement1.style.top = sectionHeight
            ? `calc(71px + ${sectionHeight}px)`
            : "100px";
          tableElement1.style.borderTop = "none";
        }

        // if (sectionHeight) {
        //   tableElement1.style.borderTop = '1px solid #e5e7eb';
        // } else {
        //   tableElement1.style.borderTop = 'none';
        // }
      }
    };

    applyStyles();

    window.addEventListener("resize", applyStyles);
    return () => {
      window.removeEventListener("resize", applyStyles);
    };
  }, [sectionHeight]);

  // tags
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseTagsData");
        if (storedBase) {
          const allTags = JSON.parse(storedBase);
          // Filter only candidate-related tags
          const candidateTags = allTags.data.filter(
            (tag) => tag.tag_type === "candidate",
          );
          setTagsList(candidateTags);
        } else {
          try {
            const baseResponse = await dispatch(
              fetchPipelineStagesList({ baseId: baseId }),
            );
            localStorage.setItem(
              "baseTagsData",
              JSON.stringify(baseResponse.payload),
            );
            if (baseResponse?.payload) {
              // Filter only candidate-related tags
              const candidateTags = baseResponse.payload.data.filter(
                (tag) => tag.tag_type === "candidate",
              );
              setTagsList(candidateTags);
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    // Set default selection to the first candidate tag when tags are loaded
    if (tagsList && tagsList.length > 0 && !selectRole) {
      setSelectRole(tagsList[0]);
    }
  }, [tagsList, selectRole]);

  const addTagsToDocument = async () => {
    if (!selectRole) {
      toast.error("Please select a tag to assign");
      return;
    }

    try {
      setTagsLoading(true);
      const selectedAppIds = rowSelectionDelete.map((app) => app.id);

      const payload = {
        app_ids: rowSelectionDelete,
        update_key: "tag_id",
        update_value: selectRole.id.toString(),
      };

      // Call the API
      const res = await dispatch(
        updateMultiApplicationData({
          baseId: baseId,
          appId: jobId,
          data: payload,
        }),
      );

      if (res.payload.status === 200) {
        // Close modal and show success message
        setAddTags(false);
        toast.success("Add tags successfully");
        // Create a thunk for this if it doesn't exist yet
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted,
        );

        if (updatedResponse.data.status === 200) {
          const newData = updatedResponse.data.data.jobApplication;
          const newPagination = {
            currentPage: updatedResponse.data.data.currentPage,
            hasNextPage: updatedResponse.data.data.hasNextPage,
            totalPages: updatedResponse.data.data.totalPages,
            pageSize: updatedResponse.data.data.limit,
            pageIndex: updatedResponse.data.currentPage - 1,
            total: updatedResponse.data.data.totalJobApplication,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedBookmarkData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            }),
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse,
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }

      // Reset the selected member
      setSelectRole(null);
    } catch (error) {
      toast.error("Failed to add tags");
      console.error("Assignment error:", error);
    } finally {
      setTagsLoading(false);
    }
  };

  // stages =

  const addStageToDocument = async () => {
    if (!selectStage) {
      toast.error("Please select a stage to assign");
      return;
    }

    try {
      setStageLoading(true);

      const payload = {
        app_ids: rowSelectionDelete,
        update_key: "stage_id",
        update_value: selectStage.id.toString(),
      };

      // Call the API
      const res = await dispatch(
        updateMultiApplicationData({
          baseId: baseId,
          appId: jobId,
          data: payload,
        }),
      );

      if (res.payload.status === 200) {
        // Close modal and show success message
        setAddStage(false);
        toast.success("Add stage successfully");
        // Create a thunk for this if it doesn't exist yet
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted,
        );

        if (updatedResponse.data.status === 200) {
          const newData = updatedResponse.data.data.jobApplication;
          const newPagination = {
            currentPage: updatedResponse.data.data.currentPage,
            hasNextPage: updatedResponse.data.data.hasNextPage,
            totalPages: updatedResponse.data.data.totalPages,
            pageSize: updatedResponse.data.data.limit,
            pageIndex: updatedResponse.data.currentPage - 1,
            total: updatedResponse.data.data.totalJobApplication,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedBookmarkData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            }),
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse,
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }

      // Reset the selected member
      setSelectStage(null);
    } catch (error) {
      toast.error("Failed to add state");
      console.error("Assignment error:", error);
    } finally {
      setStageLoading(false);
    }
  };

  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("jobPipelineStageData");
        if (storedBase) {
          const allStages = JSON.parse(storedBase);
          setStageList(allStages.stages);
        } else {
          try {
            const baseResponse = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            localStorage.setItem(
              "jobPipelineStageData",
              JSON.stringify(baseResponse.data),
            );
            if (baseResponse.status === 200) {
              setStageList(baseResponse.data.stages);
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    // Set default selection to the first candidate tag when tags are loaded
    if (stageList && stageList.length > 0 && !selectStage) {
      setSelectStage(stageList[0]);
    }
  }, [stageList, selectRole]);

  const handleAssignTeamMember = () => {
    setOpenTeamModal(true);
  };

  const useClickOutside1User = (handler) => {
    const ref = useRef(null);
    useEffect(() => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [ref, handler]);

    return ref;
  };

  const dropdownRef = useClickOutside1User(() => {
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return pipelineStageDataUser.filter((user) =>
      user.name.toLowerCase().includes(searchTerm1.toLowerCase()),
    );
  }, [pipelineStageDataUser, searchTerm1]);

  const handleUserSelect = (user) => {
    setAssignMember(user);
    setIsDropdownOpen1(false); // Close the dropdown after selection
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen1(!isDropdownOpen1);
  };

  useEffect(() => {
    const fetchHiringTeamData = async () => {
      const baseMembersDetailsString = localStorage.getItem(
        "jobByHiringTeamMembers",
      );
      // Check if data exists and is not an empty array
      if (
        baseMembersDetailsString &&
        JSON.parse(baseMembersDetailsString).length > 0
      ) {
        // Local storage data exists and is not empty, use it
        const hiringTeamMembers = JSON.parse(baseMembersDetailsString);

        // Map through hiring team members and find matching baseMembers
        const userList = hiringTeamMembers
          .map((member) => {
            // Find the matching user in baseMembers

            // Return combined data
            return {
              id: member.user_id,
              name: member?.name || "Unknown User",
              profile_pic: member?.profile_pic || null,
            };
          })
          .filter((user) => user.name !== "Unknown User");

        setPipelineStageDataUser(userList);
      } else {
        // No local storage data found or empty array, call API
        try {
          const baseResponse = await dispatch(
            fetchJobPipelineDetailsDataChange({
              baseId: parseInt(baseId),
              JobId: jobId,
            }),
          );

          // setitem
          localStorage.setItem(
            "jobByHiringTeamMembers",
            JSON.stringify(baseResponse?.payload?.data?.teamMembers || []),
          );

          if (baseResponse?.payload?.data) {
            // Assuming the API response includes hiring team data
            const hiringTeamMembers =
              baseResponse.payload.data.teamMembers || [];

            // Store in localStorage for future use

            // Process and set the data
            const userList = hiringTeamMembers
              .map((member) => {
                return {
                  id: member.user_id,
                  name: member?.name || "Unknown User",
                  profile_pic: member?.profile_pic || null,
                };
              })
              .filter((user) => user.name !== "Unknown User");

            setPipelineStageDataUser(userList);
          }
        } catch (error) {
          console.error("Error fetching hiring team data:", error);
        }
      }
    };

    if (baseId && jobId) {
      fetchHiringTeamData();
    }
  }, [baseId, jobId, dispatch]);

  const AssignMultiApp = async () => {
    if (!assignMember) {
      toast.error("Please select a team member to assign");
      return;
    }

    try {
      setIsAssign(true);
      const selectedAppIds = rowSelectionDelete.map((app) => app.id);

      const payload = {
        app_ids: rowSelectionDelete,
        update_key: "assign_to",
        update_value: assignMember.id.toString(),
      };

      // Call the API
      const res = await dispatch(
        updateMultiApplicationData({
          baseId: baseId, // Replace with your actual baseId
          appId: jobId, // Replace with your actual jobId
          data: payload,
        }),
      );
      if (res.payload.status === 200) {
        // Close modal and show success message
        setOpenTeamModal(false);
        toast.success("Applications assigned successfully");
        // Create a thunk for this if it doesn't exist yet
        const updatedResponse = await _get_ItemFeedbackList(
          pagination.pageIndex + 1,
          pagination.pageSize,
          activeFilters,
          false,
          itemAssignedTo,
          itemStatusDraft,
          itemStatusPending,
          itemStatusCompleted,
        );

        if (updatedResponse.data.status === 200) {
          const newData = updatedResponse.data.data.jobApplication;
          const newPagination = {
            currentPage: updatedResponse.data.data.currentPage,
            hasNextPage: updatedResponse.data.data.hasNextPage,
            totalPages: updatedResponse.data.data.totalPages,
            pageSize: updatedResponse.data.data.limit,
            pageIndex: updatedResponse.data.currentPage - 1,
            total: updatedResponse.data.data.totalJobApplication,
          };

          setData(newData);
          setPagination(newPagination);
          setTotalPages(updatedResponse.data.data.totalPages);

          // Update local storage with new data
          localStorage.setItem(
            "cachedBookmarkData",
            JSON.stringify({
              data: newData,
              pagination: newPagination,
              timestamp: Date.now(),
            }),
          );

          // Reset states
          setRowSelectionDelete([]);
          setDeleteOk(false);
          setIsModalOpenCheckbox(false);
          setSelectedRows({});
          setRowSelection({});
          setSelectedRowsCount(0);
        } else {
          console.error(
            "Error fetching updated item feedback list:",
            updatedResponse,
          );
          toast.error("Failed to fetch updated item feedback list");
        }
      }

      // Reset the selected member
      setAssignMember(null);
    } catch (error) {
      toast.error("Failed to assign applications");
      console.error("Assignment error:", error);
    } finally {
      setIsAssign(false);
    }
  };

  const handleApplicationDetails = (id) => {
    navigate(`/${baseId}/job/${jobId}/app/${id}/overview`);
  };

  return (
    <>
      <LoadingBar color="#ff591e" ref={loadingBarRef} />
      <div className="mx-auto max-w-full">
        <div className="px-4 sm:px-6 lg:px-8 feedback-table">
          <div className="flow-root h-full">
            <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8 h-full">
              <div className="inline-block min-w-full py-2 align-middle h-full max-w-full">
                <div className="relative  h-full  pb-[0rem] ">
                  <table
                    // className="block border-collapse overflow-x-auto  w-full feedback-col "
                     className={`block border-collapse overflow-x-auto w-full feedback-col overflow-y-auto feedback-table-height h-full ${
                      isChatOpen ? "min-w-[1100px] lg:min-w-[1100px]" : ""
                    }`}
                    // style={{

                    //   borderRight: '1px solid #e0e0e0a1'
                    // }}
                  >
                  
                    <div>
                      {pagination.totalPages === 0 ? (
                        <>
                          <thead
                      className="mq1499:sticky mq3000:fixed bg-white feedback-thead feedback-table-row overflow-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
                       style={{
                        width: verticleSidebar
                          ? `calc(100% - 241px${isChatOpen ? " - 511px" : ""})`
                          : `calc(100% - 68px${isChatOpen ? " - 520px" : ""})`,
                        zIndex: verticleSidebar ? 2 : 2,
                        borderRight: "1px solid #e0e0e0a1",
                        transitionProperty: "width",
                        transitionDuration: "300ms",
                        transitionTimingFunction: "ease-in-out",
                      }}
                      // ${header.id === 'Pic' ? 'max-w-[60px] mq1800:!min-w-[50px] mq3000:!min-w-[60px] !pl-[0.1rem] !pr-[0.4rem]' : ''}
                      // ${header.id === 'Email' ? 'mq1800:!min-w-[250px] mq1800:max-w-[360px] mq3000:!min-w-[250px]' : ''}
                      // ${header.id === 'Phone Number' ? 'mq1800:!min-w-[180px] mq1800:max-w-[360px] mq3000:!min-w-[250px]' : ''}
                      // ${header.id === 'Location' ? 'mq1800:!min-w-[170px] mq1800:max-w-[170px] mq3000:!min-w-[230px] mq3000:!max-w-[230px] ' : ''}
                    >
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr
                          key={headerGroup.id}
                          className=" flex relative w-full border-b  border-solid border-light-gray-200"
                        >
                          {headerGroup.headers.map((header) => {
                            return (
                              <th
                                key={header.id}
                                colSpan={header.colSpan}
                                scope="col"
                                className={`sticky flex flex-1 py-[0.75rem] px-[1rem] cursor-pointer text-[0.75rem] items-center justify-start
                                   leading-[1rem] text-[#52555a] font-[500]  min-w-[50px] md:min-w-[160px] lg:min-w-[50px]
                                  ${header.id === "select" ? "max-w-[50px] [&>div]:px-0 mq1300:!min-w-[50px]" : ""}                              
                                  ${header.id === "Name" ? "mq1800:!min-w-[200px] mq1800:max-w-[160px] mq3000:!min-w-[150px] mq3000:!max-w-[150px]" : ""}    
                                  ${header.id === "Headline" ? "mq1800:!min-w-[250px] mq1800:max-w-[360px] mq3000:!min-w-[320px]" : ""}
                                  ${header.id === "Tags" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "Stage" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "Task detail" ? "mq1800:!min-w-[192px] mq1800:max-w-[192px] mq3000:!min-w-[280px]" : ""}     
                                  ${header.id === "AI Rating" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "User Rating" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "Source" ? "mq1800:!min-w-[170px] mq1800:max-w-[170px] mq3000:!min-w-[156px] mq3000:!max-w-[156px]" : ""}
                                  ${header.id === "Sourced by" ? "mq1800:!min-w-[170px] mq1800:max-w-[170px] mq3000:!min-w-[165px] mq3000:!max-w-[165px]" : ""}
                                  ${header.id === "Applied at" ? "mq1800:!min-w-[160px] mq1800:max-w-[150px] mq3000:!min-w-[106px] mq3000:max-w-[140px]" : ""}
                                  ${header.id === "Last Update" ? "mq1800:!min-w-[160px] mq1800:max-w-[150px] mq3000:!min-w-[106px] mq3000:max-w-[140px]" : ""}
                                  `}
                              >
                                <div
                                  {...{
                                    className: header.column.getCanSort()
                                      ? "cursor-pointer select-none "
                                      : "",
                                    onClick:
                                      header.column.getToggleSortingHandler(),
                                  }}
                                >
                                  {flexRender(
                                    header.column.columnDef.header,
                                    header.getContext(),
                                  )}
                                  {{
                                    asc: " 🔼",
                                    desc: " 🔽",
                                  }[header.column.getIsSorted() as string] ??
                                    null}
                                </div>
                              </th>
                            );
                          })}
                          <th
                            className={`sticky bg-white flex flex-1 py-[0.75rem] px-[1rem] cursor-pointer text-[0.75rem] items-center justify-start
                             leading-[1rem] text-[#52555a] font-[500] border-r border-b  border-solid border-light-gray-200 min-w-[70px] max-w-[56px]`}
                          ></th>
                        </tr>
                      ))}
                    </thead>
                      <tbody className="flex w-full">
                        <tr className="flex w-full">
                          <td className="flex w-full" colSpan={table.getAllColumns().length}>
                            <div
                              className="w-full mt-5 flex min-h-[300px] justify-center items-center flex-col gap-y-3"
                              style={{ height: "calc(100vh - 280px)" }}
                            >
                              <ExclamationIcon />
                              <p className="text-[#0000007a] text-[13px]">
                                No results found
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      </>
                      ) : (
                        <>
  <thead
                      className="mq1499:sticky mq3000:fixed bg-white feedback-thead feedback-table-row"
                       style={{
                        width: verticleSidebar
                          ? `calc(100% - 241px${isChatOpen ? " - 511px" : ""})`
                          : `calc(100% - 68px${isChatOpen ? " - 520px" : ""})`,
                        zIndex: verticleSidebar ? 2 : 2,
                        borderRight: "1px solid #e0e0e0a1",
                        transitionProperty: "width",
                        transitionDuration: "300ms",
                        transitionTimingFunction: "ease-in-out",
                      }}
                      // ${header.id === 'Pic' ? 'max-w-[60px] mq1800:!min-w-[50px] mq3000:!min-w-[60px] !pl-[0.1rem] !pr-[0.4rem]' : ''}
                      // ${header.id === 'Email' ? 'mq1800:!min-w-[250px] mq1800:max-w-[360px] mq3000:!min-w-[250px]' : ''}
                      // ${header.id === 'Phone Number' ? 'mq1800:!min-w-[180px] mq1800:max-w-[360px] mq3000:!min-w-[250px]' : ''}
                      // ${header.id === 'Location' ? 'mq1800:!min-w-[170px] mq1800:max-w-[170px] mq3000:!min-w-[230px] mq3000:!max-w-[230px] ' : ''}
                    >
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr
                          key={headerGroup.id}
                          className=" flex relative w-full border-b  border-solid border-light-gray-200"
                        >
                          {headerGroup.headers.map((header) => {
                            return (
                              <th
                                key={header.id}
                                colSpan={header.colSpan}
                                scope="col"
                                className={`sticky flex flex-1 py-[0.75rem] px-[1rem] cursor-pointer text-[0.75rem] items-center justify-start
                                   leading-[1rem] text-[#52555a] font-[500]  min-w-[50px] md:min-w-[160px] lg:min-w-[50px]
                                  ${header.id === "select" ? "max-w-[50px] [&>div]:px-0 mq1300:!min-w-[50px]" : ""}                              
                                  ${header.id === "Name" ? "mq1800:!min-w-[200px] mq1800:max-w-[160px] mq3000:!min-w-[150px] mq3000:!max-w-[150px]" : ""}    
                                  ${header.id === "Headline" ? "mq1800:!min-w-[250px] mq1800:max-w-[360px] mq3000:!min-w-[320px]" : ""}
                                  ${header.id === "Tags" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "Stage" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "Task detail" ? "mq1800:!min-w-[192px] mq1800:max-w-[192px] mq3000:!min-w-[280px]" : ""}     
                                  ${header.id === "AI Rating" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "User Rating" ? "mq1800:!min-w-[170px] mq1800:max-w-[160px] mq3000:!min-w-[180px]" : ""}
                                  ${header.id === "Source" ? "mq1800:!min-w-[170px] mq1800:max-w-[170px] mq3000:!min-w-[156px] mq3000:!max-w-[156px]" : ""}
                                  ${header.id === "Sourced by" ? "mq1800:!min-w-[170px] mq1800:max-w-[170px] mq3000:!min-w-[165px] mq3000:!max-w-[165px]" : ""}
                                  ${header.id === "Applied at" ? "mq1800:!min-w-[160px] mq1800:max-w-[150px] mq3000:!min-w-[106px] mq3000:max-w-[140px]" : ""}
                                  ${header.id === "Last Update" ? "mq1800:!min-w-[160px] mq1800:max-w-[150px] mq3000:!min-w-[106px] mq3000:max-w-[140px]" : ""}
                                  `}
                              >
                                <div
                                  {...{
                                    className: header.column.getCanSort()
                                      ? "cursor-pointer select-none "
                                      : "",
                                    onClick:
                                      header.column.getToggleSortingHandler(),
                                  }}
                                >
                                  {flexRender(
                                    header.column.columnDef.header,
                                    header.getContext(),
                                  )}
                                  {{
                                    asc: " 🔼",
                                    desc: " 🔽",
                                  }[header.column.getIsSorted() as string] ??
                                    null}
                                </div>
                              </th>
                            );
                          })}
                          <th
                            className={`sticky bg-white flex flex-1 py-[0.75rem] px-[1rem] cursor-pointer text-[0.75rem] items-center justify-start
                             leading-[1rem] text-[#52555a] font-[500] border-r border-b  border-solid border-light-gray-200 min-w-[70px] max-w-[56px]`}
                          ></th>
                        </tr>
                      ))}
                    </thead>
                        <tbody
                          className="grid mt-[0px] relative"
                          style={{ zIndex: 1 }}
                        >
                          {table.getRowModel().rows.map((row) => {
                            const allRowsSelected =
                              table.getIsAllRowsSelected();
                            const dropdownGroups: DropdownGroup[] = [
                              {
                                options: [
                                  {
                                    label: `Delete`,
                                    className:
                                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                                    onClick: () =>
                                      handleDeleteConfirmSingle(
                                        row.original.id,
                                      ),
                                  },
                                ],
                              },
                            ];
                            return (
                              <tr
                                key={row.id}
                                data-selected={
                                  allRowsSelected ? true : selectedRows[row.id]
                                }
                                // onClick={() => handleSelect(row)}
                                className={`border-b border-solid border-light-gray-200 bg-white flex w-full relative 
                                  ${selectedRows[row.id] ? "bg-gray-100" : ""} 
                                  ${customVerticalSidebar ? "-z-[1]" : ""}`}
                                // ${customVerticalSidebar ? '-z-[1]' : 'z-[2]'} // need comment
                              >
                                {row.getVisibleCells().map((cell) => (
                                  // ${/(_Pic)$/.test(cell.id) ? 'max-w-[60px] mq1800:!min-w-[50px] mq3000:!min-w-[60px] !pl-[0.1rem] !pr-[0.4rem]' : ''}
                                  // ${/(_Email)$/.test(cell.id) ? 'mq1800:!min-w-[250px] mq1800:!max-w-[360px] mq3000:!min-w-[254px]' : ''}
                                  // ${/(_Phone Number)$/.test(cell.id) ? 'mq1800:!min-w-[180px] mq1800:!max-w-[160px] mq3000:!min-w-[250px]' : ''}
                                  // ${/(_Location)$/.test(cell.id) ? 'mq1800:!min-w-[170px] mq1800:!max-w-[150px] mq3000:!min-w-[230px]' : ''}
                                  <td
                                    key={cell.id}
                                    className={`flex items-center justify-start text-start px-[1rem] py-[0.9rem] leading-[1rem]
                                         flex-1 text-dark-black-200 max-w-[350px]
                                         ${/(_select)$/.test(cell.id) ? "max-w-[50px] [&>div]:px-0" : ""}   
                                         ${/(_Name)$/.test(cell.id) ? "mq1800:!min-w-[200px] mq1800:!max-w-[360px] mq3000:!min-w-[150px] mq3000:!max-w-[150px]" : ""}
                                         ${/(_Headline)$/.test(cell.id) ? "mq1800:!min-w-[250px] mq1800:!max-w-[160px] mq3000:!min-w-[320px]" : ""}     
                                         ${/(_Tags)$/.test(cell.id) ? "mq1800:!min-w-[170px] mq1800:!max-w-[160px] mq3000:!min-w-[180px] " : ""}   
                                         ${/(_Stage)$/.test(cell.id) ? "mq1800:!min-w-[170px] mq1800:!max-w-[160px] mq3000:!min-w-[180px] " : ""}
                                         ${/(_Task detail)$/.test(cell.id) ? "mq1800:!min-w-[192px] mq1800:!max-w-[192px] mq3000:!min-w-[280px] " : ""}
                                         ${/(_AI Rating)$/.test(cell.id) ? "mq1800:!min-w-[170px] mq1800:!max-w-[160px] mq3000:!min-w-[180px] " : ""}
                                         ${/(_User Rating)$/.test(cell.id) ? "mq1800:!min-w-[170px] mq1800:!max-w-[160px] mq3000:!min-w-[180px] " : ""}
                                         ${/(_Source)$/.test(cell.id) ? "mq1800:!min-w-[170px] mq1800:!max-w-[160px] mq3000:!min-w-[156px] mq3000:!max-w-[156px]" : ""}
                                         ${/(_Sourced by)$/.test(cell.id) ? "mq1800:!min-w-[170px] mq1800:!max-w-[160px] mq3000:!min-w-[165px] mq3000:!max-w-[165px]" : ""}
                                         ${/(_Applied at)$/.test(cell.id) ? "mq1800:!min-w-[160px] mq1800:!max-w-[150px] mq3000:!min-w-[106px] mq3000:max-w-[140px]" : ""}
                                         ${/(_Last Update)$/.test(cell.id) ? "mq1800:!min-w-[160px] mq1800:!max-w-[150px] mq3000:!min-w-[106px] mq3000:max-w-[140px]" : ""}
                                       `}
                                  >
                                    {flexRender(
                                      cell.column.columnDef.cell,
                                      cell.getContext(),
                                    )}
                                    {/* ${/(_Status)$/.test(cell.id) ? '!min-w-[110px]' : ''} */}
                                  </td>
                                ))}
                                <td
                                  className={`flex items-center text-start px-[0.75rem] py-[1rem] leading-[1rem] flex-1 min-w-[70px] max-w-[56px]
                                     text-dark-black-200 justify-center [&>button]:w-auto [&>button]:bg-transparent [&>button]:hover:bg-transparent`}
                                >
                                  <CustomMenuDropdown
                                    sections={dropdownGroups}
                                    icon={
                                      <svg
                                        stroke="currentColor"
                                        fill="none"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                        focusable="false"
                                        height="1em"
                                        width="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="12" cy="12" r="1"></circle>
                                        <circle cx="12" cy="5" r="1"></circle>
                                        <circle cx="12" cy="19" r="1"></circle>
                                      </svg>
                                    }
                                    menuItemsClassName="left-auto"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        </>
                      )}
                      
                    </div>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fixed bg-white  py-[0.5rem] px-[1rem] bottom-[7px] rounded-br-lg"
        style={{
          width: verticleSidebar ? `calc(100% - 241px${isChatOpen ? ' - 511px' : ''})`: "calc(100% - 68px)",
          zIndex: customVerticalSidebar ? [-2] : 2,
          borderBottom: "1px solid rgba(224, 224, 224, 0.63)",
          borderTop: "1px solid rgba(224, 224, 224, 0.63)",
          borderRight: "1px solid rgba(224, 224, 224, 0.63)",
        }}
      >
        <div className="relative flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-1">
              <div className="text-[0.875rem] font-[500] text-[#000000eb]">
                Page
              </div>
            </span>
            <span className="flex items-center gap-1">
              <input
                type="number"
                value={pagination.currentPage}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) : 1;
                  setPagination((prevPagination) => ({
                    ...prevPagination,
                    currentPage: page,
                  }));
                }}
                className="w-[4rem] h-[2rem] text-[0.8125rem] px-[0.75rem] rounded-md border border-gray-200 focus:outline-none"
              />

              <span className="mr-1 text-[#000000eb] text-[0.8125rem]">
                {" "}
                of {totalPages}
              </span>
            </span>

            <div className="flex items-center gap-1">
              <select
                value={table.getState().pagination.pageSize}
                onChange={(e) => {
                  table.setPageSize(Number(e.target.value));
                }}
                className="w-[6rem] h-[2rem] text-[0.8125rem] px-[0.75rem] rounded-md border border-gray-200 focus:outline-none"
              >
                {[25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
              <div className="mr-1 text-[#000000eb] text-[0.8125rem] ml-[14px]">
                {pagination.total} Items
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              className="border rounded py-2 px-2"
              onClick={handlePrevPage}
              disabled={pagination.currentPage === 1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-2 w-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </button>
            <button
              className="border rounded py-2 px-2"
              onClick={handleNextPage}
              disabled={!pagination.hasNextPage}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-2 w-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* <div open={isModalOpenCheckbox} onClose={() => { }} className={`relative z-10 w-full ${isModalOpenCheckbox ? 'common-slider-one' : 'common-slider-two'}`}
      >
        {selectedRowsCount > 0 && (
          <div className="fixed inset-y-0 right-0 flex checkbox-modal-list h-[80px] w-[800px] max-w-[800px] bottom-0 top-[-70px]">
            <div className="flex h-auto flex-col overflow-y-scroll bg-white py-6 rounded-lg w-full"
              style={{ boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1),0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}>
              <div className="px-4 sm:px-6">
                <div className="flex items-center justify-between">
                  <span className='text-dark-black-100 text-[13px] font-[700]'>{selectedRowsCount} selected</span>
                  <div className="flex items-center">
                    <div className="w-full flex items-center justify-between">
                      <div className="flex items-center gap-[0.5rem]">
                        <button
                          className='group inline-flex shrink-0 select-none items-center justify-center transition-colors
                         duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                          disabled:pointer-events-none gap-1 px-[12px] dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50
                           dark:border-surface-100 py-[8px] outline-primary disabled:text-surface-300 text-[13px]
                         text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none'
                          onClick={(id) => handleAddTags(id)}
                        >


                          Add tags
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-tag w-[0.8rem] h-[0.8rem] text-[#808080] mr-[4px]"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z" />
                          </svg>


                        </button>
                        <button
                          // onClick={(id) => handleConfirmDelete(id)}
                          className='group inline-flex shrink-0 select-none items-center justify-center transition-colors
                          duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                           disabled:pointer-events-none gap-1 px-[12px] dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50
                            dark:border-surface-100 py-[8px] outline-primary disabled:text-surface-300 text-[13px]
                          text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none'
                        >
                          Delete
                          <DeleteIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        )}
      </div> */}

      {/* add tags */}

      <Dialog open={addTags} onClose={setAddTags} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-[6px] top-[10px] hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setAddTags(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Do you want to add tags to the selected items?
                </DialogTitle>
                <Listbox value={selectRole} onChange={setSelectRole}>
                  <div className="relative mt-5">
                    <ListboxButton className="flex items-center justify-between w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                      <span className="col-start-1 row-start-1 truncate pr-6 capitalize">
                        {selectRole?.tag_name}
                      </span>
                      <ChevronDownIcon
                        aria-hidden="true"
                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                      />
                    </ListboxButton>

                    <ListboxOptions
                      transition
                      className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
                    >
                      {tagsList?.length > 0 &&
                        tagsList.map((person) => (
                          <ListboxOption
                            key={person.id}
                            value={person}
                            className={({ active }) =>
                              classNames(
                                active
                                  ? "bg-gray-200 text-[#1d2025]"
                                  : "text-gray-900",
                                "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                              )
                            }
                          >
                            <span className="block truncate font-normal group-data-[selected]:font-semibold capitalize">
                              {person.tag_name}
                            </span>

                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white"></span>
                          </ListboxOption>
                        ))}
                    </ListboxOptions>
                  </div>
                </Listbox>
              </div>
              <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                <button
                  type="button"
                  // onClick={handleDeleteConfirm}
                  className="group flex shrink-0  gap-x-2 select-none  justify-center items-center px-[14px] text-[13px] font-medium h-[32px] leading-6 transition-colors
                                    duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0
                                     py-[4px] rounded-md text-white outline-indigo-600
                                    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                  onClick={addTagsToDocument}
                >
                  Add Tags
                  {tagsLoading && (
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => setAddTags(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={quickViewMode}
        onClose={setQuickViewMode}
        className="relative z-10"
      >
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <DialogPanel className="pointer-events-auto w-screen max-w-[42rem] transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700">
                <div className="flex h-full flex-col  bg-white py-0 shadow-xl">
                  <div className="px-0">
                    <div className="sticky top-0 w-full">
                      <div className="flex h-[54px] shrink-0 items-center gap-x-4 bg-white px-4 shadow-custom-1 sm:gap-x-6 sm:px-6 lg:px-[20px]">
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-start flex-col justify-start gap-1">
                            <p className="font-[500] text-[13px] text-dark-black-200 leading-4 pb-[0px] line-clamp-1">
                              {quickData?.app_name || "No Name"}
                            </p>

                            {quickData?.app_headline ? (
                              <span className="text-gray-500  text-[13px] leading-4 font-normal mt-0">
                                {quickData.app_headline}
                              </span>
                            ) : quickData?.app_email ? (
                              <span className="text-gray-500  text-[13px] leading-4 font-normal mt-0">
                                {quickData.app_email}
                              </span>
                            ) : null}
                          </div>
                          <div className="flex justify-between items-center gap-2">
                            <button
                              onClick={() =>
                                handleApplicationDetails(quickData?.id)
                              }
                              className="rounded-md  duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                              style={{
                                transitionProperty:
                                  "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                                data-slot="icon"
                                className="w-[1.1em] h-[1.1em] text-[#000]"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                                />
                              </svg>
                            </button>
                            <button
                              onClick={() => setQuickViewMode(false)}
                              className="rounded-md  duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                              style={{
                                transitionProperty:
                                  "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                                data-slot="icon"
                                className="w-[1.1em] h-[1.1em] text-[#000]"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-start justify-between flex-col">
                      <QuickViewResponse quickData={quickData} />
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>

      <Transition.Root show={deleteOk} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 md:z-10 lg:z-10"
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full justify-center p-4 text-center sm:items-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  transition
                  className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4
                   data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full
                    sm:max-w-[500px] sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <span className="text-base font-semibold leading-6 text-gray-900">
                    Delete
                    <span> {selectedRowsCount} Application</span>
                  </span>

                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Are you sure you want to delete your application?
                    </p>
                  </div>
                  <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                    <button
                      type="button"
                      onClick={(id) => handleDeleteConfirm(id)}
                      className={`group flex shrink-0  gap-x-2 select-none  justify-center items-center px-[14px] text-[13px] font-medium h-[32px] leading-6 transition-colors
                                    duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0
                                     py-[4px] rounded-md text-white outline-indigo-600
                                    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600`}
                    >
                      Delete
                      {deleteLoading && (
                        <div className="simple-spinner-loader ">
                          <span className="!w-4 !h-4"></span>
                        </div>
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => setDeleteOk(false)}
                      className={`group inline-flex shrink-0 select-none
                        items-center justify-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline 
                        focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-1 px-[12px] dark:shadow:none border shadow-wg-xs 
                        [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50 dark:border-surface-100 py-[8px] outline-primary disabled:text-surface-300
                         text-[13px] text-dark-black-100 font-[600]
                        [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none
                     [&>span]:flex [&>span]:items-center [&>span]:gap-[8px]`}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <div
        open={isModalOpenCheckbox}
        onClose={() => {}}
        className={`relative z-10 w-full ${isModalOpenCheckbox ? "common-slider-one" : "common-slider-two"}`}
      >
        {selectedRowsCount > 0 && (
          <div className="fixed inset-y-0 right-0 flex checkbox-modal-second h-[100%] w-[800px] max-w-[800px] bottom-0 top-[-20px]">
            <div
              className="flex h-auto flex-col overflow-y-scroll bg-white py-6 rounded-lg"
              style={{
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1),0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              }}
            >
              <div className="px-4 sm:px-6">
                <div className="flex items-center justify-between">
                  <span className="text-dark-black-100 text-[13px] font-[700]">
                    {selectedRowsCount} selected
                  </span>
                  <div className="flex items-center">
                    <div className="w-full flex items-center justify-between">
                      <div className="flex items-center gap-[0.5rem]">
                        <button
                          onClick={(id) => handleAddStage(id)}
                          className="group inline-flex shrink-0 px-2 select-none items-center justify-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-1 px-12px dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50 dark:border-surface-100 py-8px outline-primary disabled:text-surface-300 text-[13px] text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none"
                        >
                          <span className="px-1"> Change Stage</span>

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-exchange w-[13px] h-[13px] text-dark-black-100"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7 10h14l-4 -4" />
                            <path d="M17 14h-14l4 4" />
                          </svg>
                        </button>
                        <button
                          onClick={(id) => handleAddTags(id)}
                          className="group inline-flex shrink-0 px-2 select-none items-center justify-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-1 px-12px dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50 dark:border-surface-100 py-8px outline-primary disabled:text-surface-300 text-[13px] text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none"
                        >
                          <span className="px-1"> Add Tags</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={3}
                            stroke="currentColor"
                            aria-hidden="true"
                            data-slot="icon"
                            className="size-6 text-dark-black-100 font-[600] opacity-80 w-[13px] h-[13px] text-dark-black-100"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6 6h.008v.008H6V6Z"
                            />
                          </svg>
                        </button>

                        <button
                          onClick={handleAssignTeamMember}
                          className="group inline-flex shrink-0 px-2 select-none items-center justify-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-1 px-12px dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50 dark:border-surface-100 py-8px outline-primary disabled:text-surface-300 text-[13px] text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none"
                        >
                          <span className="px-1">Assign Member</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-users-plus w-[13px] h-[13px] text-dark-black-100"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                            <path d="M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            <path d="M16 19h6" />
                            <path d="M19 16v6" />
                          </svg>
                        </button>
                        <button
                          onClick={(id) => handleConfirmDelete(id)}
                          className="group inline-flex shrink-0 px-2 select-none items-center justify-center transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-1 px-12px dark:shadow:none border shadow-wg-xs [--wg-border-width:1px] hover:bg-surface disabled:border-surface-50 dark:border-surface-100 py-8px outline-primary disabled:text-surface-300 text-[13px] text-dark-black-100 font-[600] [&>span]:font-[600] h-[32px] rounded-md flex-row-reverse border-[#e7e7e8] shadow-none"
                        >
                          <span className="px-1">Delete</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={3}
                            stroke="currentColor"
                            aria-hidden="true"
                            data-slot="icon"
                            className="size-6  text-dark-black-100 font-[600] opacity-80 w-[13px] h-[13px] text-dark-black-100"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* job team member assign */}
      <Dialog
        open={openTeamModal}
        onClose={() => setOpenTeamModal(false)}
        className="relative z-10"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel className="relative transform  overflow-visible rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-t-lg">
                <div className="sm:flex sm:items-start w-full">
                  <div className="mt-3 text-center sm:ml-0 sm:mt-0 sm:text-left w-full">
                    <DialogTitle
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      Assign Members
                    </DialogTitle>

                    <div className="absolute right-[6px] top-[10px] hidden pr-4 pt-4 sm:block">
                      <button
                        type="button"
                        onClick={() => setOpenTeamModal(false)}
                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <span className="sr-only">Close</span>
                        <CrossIcon />
                      </button>
                    </div>

                    <div ref={dropdownRef} className="relative mt-5 w-full">
                      <span className="table-tooltip before:!bottom-[-35px] before:!left-[41px]">
                        <button
                          onClick={toggleDropdown}
                          className={` w-full flex justify-between gap-x-2 items-center justify-start whitespace-nowrap rounded-lg text-sm font-medium transition-colors outline-offset-2 
            focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 
             [&_svg]:pointer-events-none [&_svg]:shrink-0 border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-8 px-2  py-2`}
                        >
                          <span className="block truncate text-[#1b1b1b] font-normal capitalize">
                            {assignMember ? assignMember.name : "Select user"}
                          </span>
                          <span className="pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down w-[1rem] h-[1rem] text-[#808080]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M6 9l6 6l6 -6" />
                            </svg>
                          </span>
                        </button>
                      </span>

                      {isDropdownOpen1 && (
                        <div className="absolute z-10 mt-[9px] left-[0px] top-[26px] bg-white  w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                          {/* <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm1}
              onChange={(e) => setSearchTerm1(e.target.value)}
              className="w-full px-2 py-0 border rounded text-[12px] focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div> */}
                          <ul className="max-h-60 overflow-y-auto p-0">
                            {filteredUsers.length > 0 ? (
                              filteredUsers.map((user) => (
                                <li
                                  key={user.id}
                                  onClick={() => handleUserSelect(user)}
                                  className="px-3 py-1.5 hover:bg-gray-100  mx-2 cursor-pointer text-[12px] leading-4 rounded-md flex items-center gap-2"
                                >
                                  {user.profile_pic ? (
                                    <img
                                      src={`${process.env.REACT_APP_API_BASE_URL}/${user.profile_pic}`}
                                      alt={`${user.name || "Profile"}`}
                                      className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                                    />
                                  ) : (
                                    <span
                                      className="bg-[#a3a3a3] flex items-center justify-center h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10
                       text-white text-[12px] font-medium capitalize line-clamp-1"
                                    >
                                      {user.name?.charAt(0).toUpperCase()}
                                    </span>
                                  )}
                                  <span className="font-normal block truncate text-[14px]">
                                    {user.name}
                                  </span>
                                </li>
                              ))
                            ) : (
                              <li className="px-3 py-0 text-gray-500 text-[12px]">
                                No user found
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className=" px-4 py-3 sm:flex gap-x-2 sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-[14px] py-2 text-[13px] leading-6 items-center font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setOpenTeamModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="group flex shrink-0  gap-x-2 select-none  justify-center items-center px-[14px] text-[13px] font-medium h-[32px] leading-6 transition-colors
                                    duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0
                                     py-[4px] rounded-md text-white outline-indigo-600
                                    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                  onClick={AssignMultiApp}
                >
                  {isAssign ? (
                    <>
                      Assign
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </>
                  ) : (
                    "Assign"
                  )}
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      {/* stage change */}
      <Dialog open={addStage} onClose={setAddStage} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-[6px] top-[10px] hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setAddStage(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Do you want to add stages to the selected items?
                </DialogTitle>
                <Listbox value={selectStage} onChange={setSelectStage}>
                  <div className="relative mt-5">
                    <ListboxButton className="flex items-center justify-between w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                      <span className="col-start-1 row-start-1 truncate pr-6 capitalize">
                        {selectStage?.stage_name}
                      </span>
                      <ChevronDownIcon
                        aria-hidden="true"
                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                      />
                    </ListboxButton>

                    <ListboxOptions
                      transition
                      className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
                    >
                      {stageList?.length > 0 &&
                        stageList.map((person) => (
                          <ListboxOption
                            key={person.id}
                            value={person}
                            className={({ active }) =>
                              classNames(
                                active
                                  ? "bg-gray-200 text-[#1d2025]"
                                  : "text-gray-900",
                                "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                              )
                            }
                          >
                            <span className="block truncate font-normal group-data-[selected]:font-semibold capitalize">
                              {person.stage_name}
                            </span>

                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white"></span>
                          </ListboxOption>
                        ))}
                    </ListboxOptions>
                  </div>
                </Listbox>
              </div>
              <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                <button
                  type="button"
                  className="group flex shrink-0  gap-x-2 select-none  justify-center items-center px-[14px] text-[13px] font-medium h-[32px] leading-6 transition-colors
                                    duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0
                                     py-[4px] rounded-md text-white outline-indigo-600
                                    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                  onClick={addStageToDocument}
                >
                  Add Stage
                  {stageLoading && (
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => setAddStage(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default BookmarkListing;
